// @flow
import * as React from 'react';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { Input, Radio, Select, Dropdown, Menu, Button, Tag, InputNumber } from 'antd';
import { expiries } from '../../../../../Config/expiries';
import styles from './Header.css';

type Props = {
  searchTerm: string,
  filters: any,
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
  onChangeFilter: Function,
  onClickExport: () => void,
  onClickNewSubcontractor: () => void,

}

export default class extends React.PureComponent<Props> {

  render () {
    const {
      searchTerm,
      filters,
      onChangeSearch,
      onSubmitSearch,
      onChangeFilter,
      onClickExport,
      onClickNewSubcontractor,
    } = this.props;

    const statusOptions = [
      { title: 'All', key: 'All' },
      { title: 'Active', key: 'Active' },
      { title: 'Deactivated', key: 'Deactivated' },
    ]

    const expiryOptions = [
      { title: 'In date', key: 'Valid' },
      { title: 'Missing', key: 'Missing', style: { color: 'white', background: '#ccc', borderColor: '#ccc' } },
      { title: 'Expiring soon', key: 'Expiring', style: { color: 'white', background: 'orange', borderColor: 'orange' } },
      { title: 'Expired', key: 'Expired', style: { color: 'white', background: 'red', borderColor: 'red' } },
    ]

    const exportMenu = (
      <Menu onClick={onClickExport}>
        <Menu.Item key='xlsx'>Export to Excel</Menu.Item>
        <Menu.Item key='csv'>Export to CSV</Menu.Item>
      </Menu>
    );

    return (
      <div>
        <div style={{ marginBottom: 15, display: 'flex', justifyContent: 'flex-end' }}>
          <Input.Search
            value={searchTerm}
            onChange={onChangeSearch}
            onSearch={onSubmitSearch}
            placeholder="Search"
            enterButton
            style={{ width: 250 }}
          />
        </div>

        <div className={styles.stack}>

          <div className={styles.left}>

            <Radio.Group
            value={filters.status}
            onChange={(event) => onChangeFilter('status', event.target.value)}
          >

            {statusOptions.map(option => (
              <Radio.Button
                style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
                value={option.key}
                key={option.key}
              >
                {option.title}
              </Radio.Button>
            ))}

          </Radio.Group>

          <Select
            value={filters.expiry}
            onChange={value => onChangeFilter('expiry', value)}
            allowClear
            placeholder='Select expiry'
            style={{ width: 200 }}
          >

            {expiryOptions.map(option => (
              <Select.Option key={option.key} value={option.key}>
                <Tag style={option.style}>{option.title}</Tag>
              </Select.Option>
            ))}

          </Select>

          <Select
            value={filters.document}
            onChange={value => onChangeFilter('document', value)}
            allowClear
            placeholder='Select document'
            style={{ width: 200 }}
          >

            {Object.keys(expiries).map(key => (
              <Select.Option key={key} value={key}>
                {expiries[key].title}
              </Select.Option>
            ))}

          </Select>

          <Select
            value={filters.hasRightToWork}
            onChange={value => onChangeFilter('hasRightToWork', value)}
            allowClear
            placeholder='Has RTW'
            style={{ width: 140 }}
          >

            <Select.Option key={1} value={1}>
              Yes
            </Select.Option>

            <Select.Option key={0} value={0}>
              No
            </Select.Option>

          </Select>

        </div>

          <div className={styles.right}>

            <Dropdown overlay={exportMenu}>
              <Button>
                <CloudDownloadOutlined style={{ fontSize: 16, marginTop: 3 }} />
              </Button>
            </Dropdown>

            <Button type="primary" onClick={onClickNewSubcontractor}>
              New Subcontractor
            </Button>

          </div>

        </div>

        <div className={styles.stack} style={{ marginTop: 15 }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 8, fontWeight: 500 }}>Hourly rate:</span>
            <InputNumber
              min={0}
              max={150}
              value={filters.hourly_rate_min}
              onChange={value => onChangeFilter('hourly_rate_min', value)}
              placeholder="Min"
              style={{ width: 80 }}
            />
            <span style={{ margin: '0 8px' }}>-</span>
            <InputNumber
              min={0}
              max={150}
              value={filters.hourly_rate_max}
              onChange={value => onChangeFilter('hourly_rate_max', value)}
              placeholder="Max"
              style={{ width: 80 }}
            />

            <span style={{ marginLeft: 24, marginRight: 8, fontWeight: 500 }}>Day rate:</span>
            <InputNumber
              min={0}
              max={650}
              value={filters.day_rate_min}
              onChange={value => onChangeFilter('day_rate_min', value)}
              placeholder="Min"
              style={{ width: 80 }}
            />
            <span style={{ margin: '0 8px' }}>-</span>
            <InputNumber
              min={0}
              max={650}
              value={filters.day_rate_max}
              onChange={value => onChangeFilter('day_rate_max', value)}
              placeholder="Max"
              style={{ width: 80 }}
            />
          </div>
        </div>
      </div>
    );
  }
}
